import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class RuntimeConfigService {
  readonly apiUrl = environment.apiUrl.replace(/\/$/, '');
  readonly cognitoDomain = environment.cognitoDomain.replace(/\/$/, '');
  readonly cognitoClientId = environment.cognitoClientId;
  readonly ready = Boolean(this.apiUrl && this.cognitoDomain && this.cognitoClientId);
}
